import { ITypedModel } from 'core-ts-types';
import { Model } from 'utility-ts-orm';
import { ITimeSliceTile } from '../../../interfaces/scheduler_interfaces';

export type SelectedTimeSliceModel = ITypedModel<ITimeSliceTile>;

angular.module('capability-ng-scheduler').factory(
  'ngSelectedTimeSliceModel',
  () =>
    new Model<ITimeSliceTile>({
      timeSliceStartDate: '',
      timeSliceEndDate: '',
      endDisplay: '',
      startDisplay: '',
      selected: false,
      startUnix: 0,
      endUnix: 0,
      startDayLabel: ''
    })
);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/components/time_slice_tiles/models/selected_time_slice_model.ts